export default "__VITE_ASSET__CSJ5jTpM__"